// 공통적으로 사용할 수 있는 코드
export const COMMON_CODE = {
  ALT_HCON_9001: '{0} {1}해 주세요.',
  ALT_HCON_9002: '{0} 띄어쓰기 없이 입력해 주세요.',
  ALT_HCON_9003: '{0} {1}만 입력 가능합니다.',
  ALT_HCON_9008: '{0} 형식이 올바르지 않습니다.',
  ALT_HCON_9007: '파일은 {0} 형식의 {1} 이하로 등록해주세요.',
  ALT_HCON_9082: '지정된 양식과 일치하지 않습니다.<br/><strong class="text-green">지정된 양식으로 업로드</strong>해주세요.',
  ALT_HCON_9083: '잘못된 파일입니다.<br/><strong class="text-green">엑셀 파일만 업로드 가능</strong>합니다.',
  ALT_HCON_9184: '파일이 비어있습니다.<br/><strong class="text-green">양식에 맞춰 {0}입력해 주세요.</strong>',

  ALT_HCON_9004: '{0} 완료되었습니다.',
  ALT_HCON_9011: '{0} 삭제하시겠습니까?',
  
  ALT_HCON_9009: '{0} 동의해주세요.',
  ALT_HCON_9010: '{0} 위해 필수 약관에 모두 동의해주세요.',

  ALT_HCON_9136: '{0} 필수값입니다.',
  ALT_HCON_9138: '{0} 존재하지 않습니다.',
  ALT_HCON_9139: '존재하지 않는 리소스입니다.',
  ALT_HCON_9144: '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
  ALT_HCON_9194: '유효하지 않은 접근입니다.',
  ALT_HCON_9216: '이미 {0}된 {1}입니다. 메인 화면으로 이동합니다.',

  ALT_HCON_9147: '선택된 파일 {0}(은)는</br>업로드 허용된 파일 타입이 아닙니다.',
  ALT_HCON_9148: '업로드 파일은 {0}개 까지만 가능합니다.',
  ALT_HCON_9149: '파일은 {0} 형식의 {1} 이하 파일만 가능합니다.',
  ALT_HCON_9150: '파일을 먼저 선택하십시오.',
  ALT_HCON_9151: '업로드가 거절되거나 실패한 파일이 있습니다.</br>{0}',
  ALT_HCON_9152: '업로드를 실패했습니다.</br>{0}',
  ALT_HCON_9153: '로그인이 필요합니다.',
  ALT_HCON_9154: '업로드 토큰이 만료 되었거나 유효하지 않습니다.',
  ALT_HCON_9155: '업로드 처리중 오류가 발생했습니다.</br>{0}',
  ALT_HCON_9156: '업로드 처리 결과가 올바르지 않습니다.',
  ALT_HCON_9157: '업로드 처리중 오류가 발생했습니다.',
  ALT_HCON_9158: '업로드 처리중이 아닙니다.',

  ALT_HCON_9159: '{0} 초과하였습니다.',
  ALT_HCON_9160: '{0} 정보가 존재하지 않습니다.',
  ALT_HCON_9161: '{0} 처리가 불가합니다.',
  ALT_HCON_9163: '{0} 가능합니다.',
  ALT_HCON_9164: '{0} {1} 없습니다.',

  ALT_HCON_9174: '검색어를 입력해주세요.',
  ALT_HCON_9175: '검색어는 최소 2글자를 입력해주세요.',
  ALT_HCON_9177: '검색어를 선택해 주세요.'
};

// 회원 관련 코드
export const MEMBER_CODE = {
  ALT_HCON_9005: '{0} 일치하지 않습니다. 다시 입력해 주세요.',
  
  ALT_HCON_9006: '{0} 사본을 업로드해주세요.',
  
  // 로그인
  ALT_HCON_9013: '이미 사용 중인 아이디입니다.<br/>다른 아이디를 입력해주세요.',
  ALT_HCON_9014: '아이디 또는 비밀번호가 올바르지 않습니다. 다시 확인해주세요.',
  ALT_HCON_9020: '영문, 숫자, 특수문자 포함으로 9~20자리로 입력해 주세요.',
  ALT_HCON_9021: '연속된 문자/숫자, 동일한 문자/숫자 3회 이상 사용 불가능합니다.',
  ALT_HCON_9015: '신규 비밀번호가 비밀번호 입력 규칙에 맞지 않습니다.',
  ALT_HCON_9016: '입력하신 비밀번호가 일치하지 않습니다.<br/>다시 입력해주세요.',

  ALT_HCON_9028: '사업자등록번호는 10자리 숫자여야 합니다.',      
  ALT_HCON_9029: '유효하지 않은 사업자등록번호입니다.<br/>다시 확인해 주세요.',
  ALT_HCON_9030: '해당 사업자의 등록 가능 인원을 초과 하였습니다.',              
  ALT_HCON_9031: '사업자 정보 조회에 실패했습니다.<br/>다시 인증을 진행해 주세요.',
  ALT_HCON_9032: '등록되지 않은 사업자등록번호입니다.',     	
  ALT_HCON_9038: '사업자등록번호가 확인되지 않습니다.<br/>사업자등록번호를 직접 입력하고 사업자등록증 사본을 업로드 하신 후, [관리자 승인] 절차를 거쳐 회원가입이 완료됩니다.<br/>직접 입력하시겠습니까?',
  ALT_HCON_9105: '사업자등록번호 인증을 완료해주세요.',
  ALT_HCON_9036: '근무부서와 직급을 모두 선택해 주세요.',
  
  ALT_HCON_9033: '14세 이상임에 동의해야 회원가입이 가능합니다.',
  ALT_HCON_9109: '회원가입을 위해 필수 약관에 모두 동의해주세요.',
  ALT_HCON_9110: '서비스 이용약관에 동의해주세요.',
  ALT_HCON_9111: '개인정보 수집 및 이용(필수)에 동의해주세요.',

  ALT_HCON_9037: '전화번호 형식이 올바르지 않습니다.<br/>(예: 02-123-4567 또는 031-1234-5678 형식으로 입력)',
  ALT_HCON_9107: '휴대전화 인증을 완료해주세요.',
  ALT_HCON_9034: '본인 인증이 실패했습니다. 다시 시도해주세요.',
  ALT_HCON_9215: '회원정보와 인증정보가 일치하지 않습니다.',

  ALT_HCON_9106: '아이디 중복확인을 진행해주세요.',
  ALT_HCON_9108: '이메일 중복확인을 진행해주세요.',
  ALT_HCON_9035: '이미 가입된 이메일입니다. 다른 이메일을 입력해 주세요.',
  ALT_HCON_9165: '사용자 정보가 정확하지 않습니다.',
  ALT_HCON_9170: '부가서비스 전화번호 형식이 올바르지 않습니다.<br/>(예: 1588-1234 또는 1577-1234 형식으로 입력)',
  
  // 자동 로그아웃 및 비밀번호 재설정
  ALT_HCON_9024: '고객님의 소중한 정보 보호를 위해 로그아웃 되었습니다.<br/>서비스를 계속 이용하시려면 다시 로그인해주세요.',
  ALT_HCON_9023: '고객님의 정보 보호를 위해 3분 후 자동 로그아웃될 예정입니다.<br/>계속 이용하시려면 연장하기를 눌러주세요.',
  ALT_HCON_9019: '이전에 사용한 비밀번호는 다시 사용할 수 없습니다.',
  ALT_HCON_9017: "비밀번호를 5회 이상 잘못 입력하였습니다.<br/>도용방지를 위해 '비밀번호찾기'에서 재설정하여 주세요.",
  ALT_HCON_9018: '비밀번호가 성공적으로 변경되었습니다.<br/>새 비밀번호로 로그인해주세요.',
  ALT_HCON_9141: '로그아웃에 실패하였습니다.',
  ALT_HCON_9142: '사용자 정보가 없습니다.',
  ALT_HCON_9145: '{0} 비밀번호로 사용이 불가능합니다.',
  ALT_HCON_9169: '비밀번호가 일치하지 않습니다. 다시 입력해주세요.',

  // 계정 상태 확인
  ALT_HCON_9022: '로그인 후 이용 가능한 기능입니다.<br/>로그인하시겠습니까?',
  ALT_HCON_9025: '관리자 승인이 필요한 계정입니다. 관리자에게 문의해주세요.',
  ALT_HCON_9026: '현재 사용이 제한된 계정입니다. 관리자에게 문의해주세요.',
  ALT_HCON_9027: '등록되지 않은 회원정보입니다. 입력한 정보를 다시 확인해주세요.',
  ALT_HCON_9140: '<span class="text-red">이미 로그인되어 있는 회원입니다.</span><br/>로그아웃 합니다.',
  ALT_HCON_9143: '비밀번호 사용기간이 만료되었습니다.',
  ALT_HCON_9166: '승인이 반려된 계정입니다. 관리자에게 문의해주세요.',
  ALT_HCON_9167: '현재 잠겨있는 계정입니다.<br/>비밀번호 찾기 화면으로 이동합니다.',
  ALT_HCON_9168: '탈퇴한 회원입니다.',
  ALT_HCON_9219: '탈퇴 후 30일 이내 재가입 불가합니다.',

  // 계좌관리
  ALT_HCON_9041: '계좌인증에 실패하였습니다.<br/>계좌정보를 다시 확인해주세요.',
  ALT_HCON_9042: '환불 계좌 등록이 완료되었습니다. <br/><span class="text-green">관리자의 승인 후 사용 가능</span>합니다.',
  ALT_HCON_9114: '실지명의계좌 등록이 완료되었습니다.<br/><span class="text-green">관리자의 승인 후 사용 가능</span>합니다.',

  // 탈퇴관리
  ALT_HCON_9046: 'H캐시 {0}원이 남아 있습니다.<br/>환불 완료 후 탈퇴가 가능합니다.',
  ALT_HCON_9047: '회원탈퇴를 계속 진행하시겠습니까?',
  ALT_HCON_9104: '회원탈퇴 처리 완료되었습니다.',
  ALT_HCON_9103: '탈퇴를 취소하고 이전 페이지로 이동하시겠습니까?',
  
  // H캐시 관리
  ALT_HCON_9048: '신용카드 및 계좌이체는 <span class="text-green">1,000원 이상부터 충전 가능</span>합니다.',
  ALT_HCON_9049: '충전 할 H캐시 금액을 최종 확인하였으면, H캐시 구매에 동의해주세요.',
  ALT_HCON_9050: 'H캐시 충전취소를 하시겠습니까?',
  ALT_HCON_9051: 'H캐시 충전이 취소되었습니다.',
  ALT_HCON_9112: 'H캐시 충전이 완료되었습니다.',
  ALT_HCON_9113: 'H캐시 환불 신청이 완료되었습니다.',
  ALT_HCON_9178: '충전 시, H캐시 보유한도 {0}을 초과합니다.<br/>현재 보유 H캐시를 확인해주세요.',

  // 적립금 관리
  ALT_HCON_9220: '잔여 적립금 {0}원이 남아 있습니다.<br/>탈퇴 후 해당 적립금은 소멸됩니다.<br/>탈퇴하시겠습니까?',

  // 쿠폰발송관리
  ALT_HCON_9094: '기존에 등록된 번호입니다.',
  ALT_HCON_9091: '이미 기본 발신번호로 설정된 번호입니다.<br/>다른 발신번호를 선택해주세요.',
  ALT_HCON_9092: '승인되지 않은 유선전화번호는 기본 번호로 설정할 수 없습니다.',
  ALT_HCON_9093: '회원정보의 휴대전화번호도 {0}로 변경됩니다.<br/>변경하시겠습니까?',
  ALT_HCON_9095: '발신번호 접수가 완료되었습니다.<br/><span class="text-green">영업일 기준 1일 이내 승인 완료</span> 처리 됩니다.',

  ALT_HCON_9098: '선택하신 연락처를 삭제하시겠습니까?<br/>삭제 후에는 복구할 수 없습니다.',
  ALT_HCON_9099: '연락처가 등록되었습니다.',
  ALT_HCON_9100: '이미 등록된 휴대전화번호입니다.',
  ALT_HCON_9179: '등록된 연락처 정보가 초기화 됩니다.<br/>계속 진행하시겠습니까?',
  ALT_HCON_9180: '선택된 연락처가 없습니다.<br/>등록할 연락처를 선택해 주세요.',

  ALT_HCON_9117: 'MY 메시지 제목을 입력해주세요.',
  ALT_HCON_9118: 'MY 메시지 내용을 입력해주세요.',
  ALT_HCON_9096: 'MY 메시지가 저장되었습니다.<br/>문자 메시지는 <span class="text-green">최대 20개까지 등록</span>할 수 있습니다.',
  ALT_HCON_9097: '작성 중인 내용은 저장되지 않습니다.<br/>목록으로 이동하시겠습니까?',
  ALT_HCON_9116: '선택하신 쿠폰 메시지를 삭제하시겠습니까?',
  ALT_HCON_9115: '선택하신 쿠폰 상단이미지를 삭제하시겠습니까?',
  ALT_HCON_9137: 'MY 배너는 최대 50개까지 등록이 가능합니다.',
  ALT_HCON_9185: '쿠폰 메시지는 <span class="text-green">최대 20개까지 등록</span>할 수 있습니다.<br/>쿠폰 메시지 목록에서 삭제 후 시도해주세요.',
  ALT_HCON_9186: 'MY 메시지가 삭제되었습니다.',
  
  // 1:1문의관리
  ALT_HCON_9101: '문의하신 내용이 등록되었습니다.<br/>빠른 시일 내 정성껏 답변 드리겠습니다.',
  ALT_HCON_9102: '작성 중인 내용은 저장되지 않습니다.<br/>정말 취소하시겠습니까?',
  
};

// 주문 관련 코드
export const ORDER_CODE = {
  // 상품
  ALT_HCON_9039: '해당 상품은 정책 외 거래를 제한하기 위해<br/>사업자 인증을 위한 사업자 계좌 등록이 필요합니다.<br/>계좌 등록 후 관리자 승인까지 최대 1일 소요되며,<br/>승인완료 후 상품 구매가 가능합니다.<br/>계좌를 등록하시겠습니까?',
  ALT_HCON_9043: '수정 중인 내용이 저장되지 않습니다. 정말 나가시겠습니까?',
  ALT_HCON_9044: '주문 및 예약 내역이 존재합니다.<br/>확인 후 처리 진행바랍니다.',
  ALT_HCON_9045: '예약발송 및 주문 내역 중 발송 실패 건이 존재하여 탈퇴가 불가능합니다.<br/>해당 주문을 취소하신 뒤 다시 시도해주세요.',
  ALT_HCON_9056: '이 상품은 옵션이 있는 상품입니다.<br/>상품 상세에서 옵션을 선택해 주세요.',
  ALT_HCON_9067: '<strong class="text-green">노출중지 상품</strong>으로 상품 상세를 보실 수 없습니다.',
  ALT_HCON_9126: '선택된 상품이 없습니다.',
  ALT_HCON_9218: '지금은 <strong class="text-green">환금성 상품 주문 가능 시간</strong>이 아닙니다.<br/>판매 시간 내에 다시 시도해 주세요.<br/><br/>- 판매시간 : 09:00 ~ 18:00 (공휴일 제외)',

  // 장바구니&임시저장&견적서 등
  ALT_HCON_9052: '이미 장바구니에 담은 상품입니다.',
  ALT_HCON_9053: '장바구니에 담았습니다.<br/>장바구니로 이동하시겠습니까?',
  ALT_HCON_9054: '장바구니에는 최대 20개의 상품만 담을 수 있습니다.<br/>장바구니를 비운 후 다시 시도해 주세요.<br/>장바구니로 이동하시겠습니까?',
  ALT_HCON_9055: '선택하신 상품을 <strong class="text-green">장바구니에서 삭제</strong>하시겠습니까?',
  ALT_HCON_9068: '환금성 상품은 정책에 따라 구매 시 관리자 승인 후 발송됩니다.<br/>(주문일 기준 영업시간 1시간 이내 발송됩니다.)<br/>보다 자세한 내용은 1:1 문의를 통해 확인하실 수 있습니다.',
  ALT_HCON_9069: '환금성 상품과 일반 상품은 함께 구매할 수 없습니다.<br/>불편하시더라도 각각 따로 구매해 주시기 바랍니다.',
  ALT_HCON_9070: '선택하신 주문서에서 구매불가한 상품은 제외 후 주문페이지로 이동합니다.',
  ALT_HCON_9071: '주문서를 임시 저장하였습니다.<br />주문서는 <span class="text-green">최대 20개까지 저장</span>하실 수 있습니다.<br />저장하신 주문은 홈페이지 상단 <span class="text-green">[주문서 임시저장]</span>에서 다시 주문하실 수 있습니다.',
  ALT_HCON_9072: '주문서는 최대 <span class="text-green">20개까지 저장</span>할 수 있습니다.<br/>새로운 주문을 저장하려면 홈페이지 상단 <span class="text-green">[주문서 임시저장]에서 기존 주문 일부를 삭제</span> 해 주세요.',
  ALT_HCON_9119: '선택하신 주문서 임시저장을 삭제하시겠습니까?',
  ALT_HCON_9120: '구매 상품에 환금성(상품권, 금액권 등) 상품 포함 시 <strong class="text-green">관리자 승인 후 1영업일 이내 일괄 발송</strong>됩니다.<br/>관련 문의사항은 1:1 문의 부탁드립니다.<br/><br/>- 환금성 상품 판매시간 : 09:00~18:00 (공휴일 제외)',

  // 주문정보
  ALT_HCON_9073: '주문정보 내 미입력 사항을 확인해 주세요.',
  ALT_HCON_9074: '1,000건 초과 발송은 개별 발송이 제한되며, 예약발송으로만 진행할 수 있습니다.',
  ALT_HCON_9075: '<span class="text-green">등록된 수신자 정보가 모두 삭제</span>되며, 수신자 수기 입력창으로 전환됩니다.<br />일반발송 전환을 하시겠습니까?',
  ALT_HCON_9076: '현재 상품에 입력된 발송 메시지 정보가 모든 상품에 동일하게 적용이 되며, 기존 개별 설정은 덮어쓰기가 됩니다.<br/>계속 진행하시겠습니까?',
  ALT_HCON_9077: '현재 상품에 입력된 발송 메시지 정보가 모든 상품에 동일하게 적용이 해지가 되며, 다른 상품에 적용되었던 설정은 제거가 됩니다.<br/>계속 진행하시겠습니까?',
  ALT_HCON_9078: "알림톡/쿠폰 발송 메시지를 수정하면 해당 상품의 '모든 상품에 동일하게 복사 적용'이 자동 해제됩니다.<br/>계속 진행하시겠습니까?<br/>※ 현재 상품은 개별 발송 메시지로 발송됩니다.",
  ALT_HCON_9079: '입력된 수신자 정보를 모두 삭제하시겠습니까?',
  ALT_HCON_9080: '주문서 수정페이지로 이동하시겠습니까?',
  ALT_HCON_9081: '주문취소를 하시겠습니까?',
  ALT_HCON_9084: '등록된 수신자 정보가 초기화 됩니다.<br/>계속 진행하시겠습니까?',
  ALT_HCON_9085: '선택된 수신자 번호가 없습니다.<br/>수신자 번호를 선택해 주세요.',
  ALT_HCON_9086: '수신자 등록 결과를 확인하실 수 있습니다.<br/>다운로드된 파일은 수신자를 수정하여 재등록이 가능합니다.',
  ALT_HCON_9087: '업로드 결과가 없습니다.<br/>양식을 다시 업로드 해주세요.',
  ALT_HCON_9122: '수신자로 등록할 연락처를 선택해 주세요.',
  ALT_HCON_9191: '{0} 상품의 <span class="text-green">{1} 구매 가능 수량</span>은 <span class="text-green">{2}개</span>입니다.',
  ALT_HCON_9192: '해당 상품은 동일한 번호로 최대 {0}건까지 발송할 수 있습니다.',
  ALT_HCON_9193: '예약발송이 불가능한 상품이 포함되어 있습니다.',

  // 결제정보
  ALT_HCON_9012: '<span class="text-green">{0}결제금액이 {1}금액을 초과</span>하였습니다.<br/>{1}금액에 맞추어 적용됩니다.',
  ALT_HCON_9121: '주문자 아이디 기준 1일 구매발송 한도는 10,000,000원 입니다.',
  ALT_HCON_9146: '사용 가능한 {0} 잔액이 부족합니다.',
  ALT_HCON_9161: '환급 처리 중 금액 불일치가 발생하였습니다.',
  ALT_HCON_9171: '지원하지 않는 결제수단입니다.',
  ALT_HCON_9172: '{0} 오류가 발생하였습니다.</br>잠시 후 다시 시도해주세요.',
  ALT_HCON_9173: '{0} 실패했습니다.</br>잠시 후 다시 시도해주세요.',
  ALT_HCON_9182: '<span class="text-green">선택하신 결제 금액이 주문 금액보다 적습니다.</span><br/>주문 금액에 맞게 결제 금액을 다시 확인해 주세요.',
  ALT_HCON_9195: '결제 금액과 주문 금액이 일치하지 않습니다.\n주문 금액에 맞게 결제 금액을 다시 확인해 주세요.', 
  ALT_HCON_9196: '결제 처리 중 통신 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
  ALT_HCON_9197: '결제 응답을 확인하지 못했습니다. 고객센터에 문의해주세요.',
  ALT_HCON_9198: '시스템 장애로 인해 %s가 중단되었습니다.',
  ALT_HCON_9199: '결제 기관에 의해 %s(이)가 거절되었습니다. 카드 또는 계좌 상태를 확인해주세요.',
  ALT_HCON_9200: '%s 금액 정보가 일치하지 않습니다. 다시 시도해주세요.',
  ALT_HCON_9201: '시스템 오류로 %s 처리를 완료하지 못했습니다. 고객센터에 문의바랍니다.',
  ALT_HCON_9202: '데이터 암/복호화 처리에 실패하였습니다.',
  ALT_HCON_9203: '요청정보가 확인되지 않습니다. 새로고침 후 재시도 바랍니다.',
  ALT_HCON_9204: '이니시스 결제 모듈을 사용 할 수 없습니다. 새로고침 후 재확인 바랍니다.',
  ALT_HCON_9205: '{0} 수단을 선택해주세요.',
  ALT_HCON_9206: '이니시스 통신이 실패하였습니다.',
  ALT_HCON_9207: '이니시스 결제에 실패하였습니다.',
  ALT_HCON_9208: '이니시스 결제 망취소에 실패하였습니다.',
  ALT_HCON_9209: '이니시스 결제 취소에 실패하였습니다.',
  ALT_HCON_9210: '이니시스 결제 부분취소 에 실패하였습니다.',
  ALT_HCON_9211: 'JSON 변환에 실패하였습니다.',
  ALT_HCON_9212: '유효한 결제수단이 아닙니다.',
  ALT_HCON_9213: 'MID 정보가 누락되었습니다.',
  ALT_HCON_9214: '데이터 암/복호화 처리에 실패하였습니다.',


  // 마이페이지
  ALT_HCON_9040: "승인된 환불계좌가 없습니다.<br/><strong class='text-green'>환불계좌 등록 및 승인요청</strong>하시겠습니까?",
  ALT_HCON_9088: '즉시발송 및 예약발송이 처리된 경우 CS로만 처리가 가능합니다.	',
  ALT_HCON_9089: '결제취소 하시겠습니까? 취소 완료까지 최대 10분이 소요되며, 예약발송의 경우만 전체취소가 가능합니다.',
  ALT_HCON_9090: '쿠폰이 재발송 되었습니다.',
  ALT_HCON_9133: '즉시발행 및 예약발행이 처리된 경우 CS로만 처리가 가능합니다.',
  ALT_HCON_9134: '결제취소 하시겠습니까? 취소 완료까지 최대 10분이 소요되며, 예약발행의 경우만 전체취소가 가능합니다.',
  ALT_HCON_9135: `1일 다운로드 가능 횟수 <span class="text-green">10회를 초과</span>하였습니다.<br/>내일 다시 시도해주세요.`,
  ALT_HCON_9183: '변경 수신자 번호가 기존 수신자 번호와 동일합니다.',

  // 핀발행
  ALT_HCON_9124: '핀발행 요청에 <span class="text-green">이미 추가하신 상품</span>입니다.',
  ALT_HCON_9125: '핀발행 요청에 이용하실 수 있는 상품은 <span class="text-green">최대 5개</span> 입니다.',
  ALT_HCON_9127: '핀발행 주문 시 <span class="text-green">{0}의 최소 주문 수량은 {1}개 입니다.</span><br />최소 주문 수량을 확인해 주세요.',
  ALT_HCON_9128: '핀발행은 <span class="text-green">최대 5,000개</span>까지만 주문 가능합니다.',
  ALT_HCON_9129: '핀발행 접수가 완료되었습니다.<br/>영업일 기준 1일 이내 승인 완료 처리 됩니다.',
  ALT_HCON_9130: '<p class="ws-nowrap"><span class="text-green">핀발행 서비스 이용 조건을 확인하시고 동의</span>해 주세요.</p>동의 후에 요청 절차가 진행됩니다.',
  ALT_HCON_9131: '<strong class="text-green">유효기간을 변경하면 선택한 상품과 검색 결과가 모두 초기화</strong>됩니다.<br/>선택하신 유효기간을 적용하시겠습니까?',
  ALT_HCON_9132: '1,000건 초과 발행은 즉시발행이 제한되며, 예약발행으로만 진행할 수 있습니다.',
  ALT_HCON_9176: '심사 결과를 안내받을 방법을 선택해 주세요.<br/><span class="text-green">알림톡 또는 이메일</span>로 받아보실 수 있습니다.',


};

// 견적서 관련 코드
export const ESTIMATE_CODE = {
  ALT_HCON_9057: '이미 견적서에 담긴 상품 입니다.<br/>온라인견적서로 이동하시겠습니까?',
  ALT_HCON_9058: '견적담기 하였습니다.<br/>온라인견적서로 이동하시겠습니까?',
  ALT_HCON_9059: '견적담기는 최대 50개의 상품만 담을 수 있습니다.<br/>담은 상품 불러오기에서 담은 상품을 삭제 후 이용해주세요.<br/>담은 상품 불러오기를 하시겠습니까?',
  ALT_HCON_9060: '견적서에 <span class="text-green">이미 추가하신 상품</span>입니다.',
  ALT_HCON_9061: '선택하신 상품을 삭제하시겠습니까?',
  ALT_HCON_9062: '현재 견적에 담긴 상품이 없습니다.',
  ALT_HCON_9063: '온라인 견적서에 등록할 상품을 선택해주세요.',
  ALT_HCON_9064: '선택하신 상품을 온라인 견적서에 추가하시겠습니까?',
  ALT_HCON_9065: '온라인 견적서를 인쇄하였습니다.',
  ALT_HCON_9066: '온라인 견적서를 다운로드합니다.<br/>다소 시간이 소요될 수 있습니다.',
  ALT_HCON_9123: '온라인 견적서에는 <strong class="text-green">최대 20개 까지만</strong> 상품을 추가할 수 있습니다.',
  ALT_HCON_9181: '삭제할 상품을 선택해주세요.',
  ALT_HCON_9187: '견적명을 입력해주세요. (최대 20자)',
  ALT_HCON_9188: '기업명을 입력해주세요.',
  ALT_HCON_9189: '담당자명을 입력해주세요.',
  ALT_HCON_9190: '견적서는 유효기간이 같은 상품만 추가 가능합니다.<br/>선택한 상품의 유효기간을 확인해주세요.'
};

// 기타 관련 코드
export const ETC_CODE = {
  ALT_HCON_9217: 'e쿠폰 제휴 관련하여 문의가 있으신 경우<br />아래 이메일로 보내주시면 확인 후 안내드리겠습니다.<br /><button type="button" id="copy-btn" class="mt10 link text-gray">hcon@hyundaiezwel.com</button>'
}